// Related products

if (!customElements.get('product-recommendation')) {
	customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
		constructor() {
			super();
			this.renderSection();
		}

		async renderSection() {
			try {
				const response = await fetch(this.dataset.url);
				const responseText = await response.text();
				const doc = new DOMParser().parseFromString(responseText, 'text/html');

				const fetchSection = doc.querySelector('[data-product-list]');
				const section = this.querySelector('[data-product-list]');

				if (fetchSection?.innerHTML.trim() && section) {
					section.innerHTML = fetchSection.innerHTML;
					this.removeAttribute('style');
					relatedProductsSlider();

				}

				if (window.lazyLoadEnabled === "true") {
					reloadLazyLoad();
				}

			} catch (err) {
				console.error('Failed to load product recommendations:', err);
			}
		}
	});
}

const relatedProductsSlider = () => {
	const featuredCarousels = document.querySelectorAll('.featured-products-carousel');
	if (featuredCarousels) {
		featuredCarousels.forEach((carousel) => {
				new Swiper(carousel, {
					slidesPerView: 5,
					spaceBetween: 24,
					navigation: {
						nextEl: carousel.querySelector('.slider-nav__btn--next'),
						prevEl: carousel.querySelector('.slider-nav__btn--prev'),
					},
					pagination: {
						el: carousel.querySelector('.swiper-pagination'),
						clickable: true,
					},
					scrollbar: {
						el: ".swiper-scrollbar",
						hide: false,
					},
					breakpoints: {
						320: {
							slidesPerView: 'auto',
						},
						576: {
							slidesPerView: 'auto',
						},
						992: {
							slidesPerView: 4,
						},
						1600: {
							slidesPerView: 5,
						}
					},
				});
			}
		);
	}
}
